if(!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.svgArrow = this.getAttribute('data-svg-arrow');
      this.disabled = this.getAttribute('data-disabled') == 'true' ? true : false;
    }

    connectedCallback() {
      if(!Flickity || this.disabled) return;

      this.slider = new Flickity(this, {
        adaptiveHeight: false,
        draggable: true,
        cellAlign: 'left',
        groupCells: 3,
        wrapAround: true,
        pageDots: false,
        imagesLoaded: true
      });

      const previous = this.querySelector('.previous');
      const next = this.querySelector('.next');

      if(!previous || !next) return;

      previous.innerHTML = this.svgArrow;
      next.innerHTML = this.svgArrow;

      const review = this.querySelector('.yotpo.bottomLine');

      const observer = new MutationObserver(() => {
        this.slider.resize();
      });

      if(review) observer.observe(review, { childList: true, subtree: true });

      this.slider.on('settle', (event, cellElement) => {
        this.slider.reloadCells();
        this.slider.resize();
      });
    }
  }

  customElements.define('product-slider', ProductSlider);
}
